import { Component, OnInit, Input, HostListener, OnDestroy, ViewChild, ElementRef, Renderer2, ViewChildren, QueryList } from '@angular/core';
import { LoginService } from '../services/login.service';
import { Action, GroupAction } from '../objects/DetailObject';
import { HeaderService } from '../services/header.service';
import { TokenManager } from '../Globals';
import { NgProgress, NgProgressRef } from '@ngx-progressbar/core';
import { Router } from '@angular/router';
import { Globals } from '../objects/Globals';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { WorkspaceService } from '../services/workspace.service';
import { MainLoadingService } from '../services/main-loading.service';
import { Subscription } from 'rxjs';
import { MatMenuTrigger, MatMenu } from '@angular/material';
import { WorkflowReturnService } from '../services/workflow-return.service';

@Component({
  selector: 'app-primary-menu',
  templateUrl: './primary-menu.component.html',
  styleUrls: ['./primary-menu.component.css'],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({transform: 'translateY(-100%)'}),
        animate('200ms ease-in', style({transform: 'translateY(0%)'}))
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({transform: 'translateY(-100%)'}))
      ])
    ])
  ]
})
export class PrimaryMenuComponent implements OnInit, OnDestroy {

  private currentSessionId:string;
  private cardId:string;
  private groupList:GroupAction[] = [];
  private currentMenu:string;
  private sub: Subscription;
  hiddenList = [];
  hiddenActionList: Action[] = [];
  menuActions:Action[] = [];
  navbarOpen = false;
  progressRef: NgProgressRef;
  showBtnMore: boolean = false;
  actionsReady: boolean = false;
  collapsed: boolean = false;

  @Input() fixHeight:number = 0;
  @ViewChild('primaryMenu') public primaryMenu: ElementRef;
  @ViewChild('menuContainer') public menuContainer: ElementRef;
  @ViewChild('hiddenMenu') public hiddenMenu: ElementRef;

  @ViewChildren('matMenuTrigger') matMenuTriggerList : QueryList<MatMenuTrigger>;

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if(this.elRef.nativeElement.contains(event.target)) {
      // target is in this component
    } else {
      this.closeAll();
    }
  }

  constructor(
    private loginService:LoginService,
    private headerService:HeaderService,
    private router: Router,
    private tokenManager:TokenManager,
    private globals:Globals,
    private workspaceService: WorkspaceService,
    private mainLoadingService: MainLoadingService,
    private progress: NgProgress,
    private render: Renderer2,
    private elRef: ElementRef,
    private workflowReturnService: WorkflowReturnService) {

      this.sub = headerService.selectedMenuChanged$.subscribe(result => {
        if (result == 'clearSelected'){
          this.currentMenu = '';
          this.tokenManager.delete("BRNCurrentMenu");
        }
      });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (event.target.innerWidth < 992) {
       this.navbarOpen = false;
       this.hiddenActionList = [];
      //  this.hiddenList = [];
      this.onCollapsedMenu();
      this.showBtnMore = false;
      this.collapsed = true;
    }
    else{
      this.collapsed = false;
      if(this.actionsReady) this.updateActionsDisplay();
    }
  }

  toggleNavbar() {
    this.navbarOpen = !this.navbarOpen;
  }

  returnId(item: Action){
    if (item.ActionName){
      return item.ActionName.replace(/\s/g, '') + "_link";
    }
    else{
      return "nice_link";
    }
    
  }

  loadHeaderMenu(){
    if (this.globals.Session){
      this.headerService.createHeaderCard().subscribe(id=> {
        this.cardId = id;
        this.headerService.getHeaderMenuItems(id).subscribe(groups=>
          {
            this.groupList = JSON.parse(groups);
            if (this.groupList){
              this.sortGroupMenuActions(this.groupList);
              this.menuActions = [];
              var menuAction:Action[] = [];
              var baseGroup = this.groupList.filter(x => x.GroupId == "00000000-0000-0000-0000-000000000000");
              var group = this.groupList.filter(x => x.GroupId != "00000000-0000-0000-0000-000000000000");
              baseGroup.forEach(group => {
                group.Actions.forEach(action => {
                  menuAction.push(action);
                });
              });
    
              group.forEach(group => {
                var action = new Action();
                action.ActionName = group.GroupDisplay;
                if (group.Actions) {
                  action.SubActions = [];
                  var subActions = this.sortMenuActions(group.Actions);
                  subActions.forEach(result => {
                    action.SubActions.push(result);
                  });
                }
                menuAction.push(action);
              });
    
              this.menuActions = this.sortMenuActions(menuAction);
              // if (this.menuActions.length > 10) {
              //   this.extraMenuActions  = this.menuActions.slice(10);
              //   this.menuActions = this.menuActions.slice(0, 10);
              // }
              if (this.tokenManager.retrieve("BRNCurrentMenu")){
                this.currentMenu = this.tokenManager.retrieve("BRNCurrentMenu").replace(/"/g,"");
              }
            }
          }
        );
      });
    }
    
  }

  sortMenuActions(menuAction:Action[]):Action[]{
    return menuAction.sort((a:Action,b:Action) => { 
      if(a.ActionOrder > b.ActionOrder){
        return 1;
      }else if(a.ActionOrder < b.ActionOrder){
        return -1;
      }else{
        return 0;
      }
      });
  }

  sortGroupMenuActions(groupAction:GroupAction[]){
    this.groupList = groupAction.sort((a:GroupAction, b:GroupAction) => {
      if(a.GroupOrder > b.GroupOrder){
        return 1;
      }else if(a.GroupOrder < b.GroupOrder){
        return -1;
      }else{
        return 0;
      }
      });
  }

  selectMenuHeader(selectedCommand:string){
    this.currentMenu = selectedCommand;
    this.tokenManager.store("BRNCurrentMenu", this.currentMenu);
    this.mainLoadingService.setProgressBar(true);
    if (!this.cardId){
      this.headerService.createHeaderCard().subscribe(id => {
        this.cardId = id;
      })
    }
    this.headerService.selectHeaderMenuItems(this.cardId, selectedCommand).subscribe(result =>{
      var resultObject = JSON.parse(result);
      if(resultObject.ReturnType == "0"){
        if(resultObject.Arguments){
          var path = [];
          resultObject.Arguments.forEach(element => {
            path.push(element);
          });
          this.router.navigated = false;
          this.mainLoadingService.setProgressBar(false);
          // this.progressRef.complete();
          this.router.navigate(path);
          this.navbarOpen = !this.navbarOpen;
        }
      }
      else{
        this.workflowReturnService.handleWorkflowReturn(resultObject);
        this.mainLoadingService.setProgressBar(false);
        this.navbarOpen = !this.navbarOpen;
        this.currentMenu = null;
      }
    }, error => {
      this.mainLoadingService.setProgressBar(false);
      //this.progressRef.complete();
    });
  }
  
  hasActiveSubAction(menuItem: Action){
    return menuItem.SubActions.findIndex(x => x.ActionCommand == this.currentMenu) > -1;
  }

  ngOnInit() {
    this.collapsed = window.innerWidth < 992;
    this.progressRef = this.progress.ref();
    this.currentSessionId = this.globals.Session.SessionKey;
    this.loadHeaderMenu();
  }

  ngOnDestroy(){
    if (this.sub) this.sub.unsubscribe();
  }

  afterInit(){
    this.actionsReady = true;
    this.updateActionsDisplay();
  }

  updateActionsDisplay(){
    let availableSpace: any;

    availableSpace = this.primaryMenu.nativeElement.offsetWidth;

    if (this.menuContainer){
      let actionsWidth = this.menuContainer.nativeElement.offsetWidth;

      actionsWidth = actionsWidth + 44;
  
      if (actionsWidth > availableSpace){
        
        const id = this.menuContainer.nativeElement.children[this.menuContainer.nativeElement.children.length - 1].getAttribute("id");

        if (this.hiddenList.length > 0){
          this.render.insertBefore(this.hiddenMenu.nativeElement, this.menuContainer.nativeElement.children[this.menuContainer.nativeElement.children.length - 1], this.hiddenMenu.nativeElement.children[0]);

          this.hiddenActionList.unshift(this.menuActions.find(x => x.ActionName == id))
        }
        else{
          this.render.appendChild(this.hiddenMenu.nativeElement, this.menuContainer.nativeElement.children[this.menuContainer.nativeElement.children.length - 1]);

          var index = this.hiddenActionList.findIndex(x => x.ActionName == id);
          if (index > -1){
            this.hiddenActionList.splice(index, 1);
          }
          else{
            this.hiddenActionList.unshift(this.menuActions.find(x => x.ActionName == id))
          }
        }
        
        // record width
        this.hiddenList.push(actionsWidth);
  
        // show the btn
        this.showBtnMore = true;
      }
      else{
        this.moveItemToVisible(availableSpace);
  
        // Hide the dropdown btn if hidden list is empty
        if(this.hiddenList.length < 1) {
          this.showBtnMore = false;
        }
      }
  
      // Recur if the visible list is still overflowing the nav
      if(actionsWidth > availableSpace) {
        this.updateActionsDisplay();
      }
    }
    
  }

  moveItemToVisible(availableSpace: number){
    if(availableSpace > this.hiddenList[this.hiddenList.length-1]) {
      // Move the item to the visible list
      this.render.appendChild(this.menuContainer.nativeElement, this.hiddenMenu.nativeElement.children[0]);
      this.hiddenList.pop();
      this.hiddenActionList.shift();

      //recur if still have item that can move to visible list
      this.moveItemToVisible(availableSpace);
    }
  }
  
  onCollapsedMenu(){
    // this.updateActionsDisplay();
   for (var i = 0; i < this.hiddenMenu.nativeElement.children.length; i++){
    this.render.appendChild(this.menuContainer.nativeElement, this.hiddenMenu.nativeElement.children[i]);
   }
  }

  menuOpened(actionName){
    this.matMenuTriggerList.forEach(matMenu => {
      if (matMenu.menuOpen){
        if (this.hiddenActionList.findIndex(x => x.ActionName == actionName) < 0 && matMenu.menuData != actionName){ // not in hidden menu and not the current opened menu
          // close the others
          matMenu.closeMenu();
        }
      }
    });
  }

  closeAll(){
    this.matMenuTriggerList.forEach(matMenu => {
      if (matMenu.menuOpen){
        matMenu.closeMenu();
      }
    });
  }
}
